<template lang="pug">
.v-price-tariff.price-tariff(v-if="price" :class="['price-tariff--' + view, 'price-tariff--' + size]")
	.price-tariff__title(v-if="price.title") {{price.title}}
	.price-tariff__groups
		v-svg-icon.price-tariff__icon(v-if="view === 'delivery'" icon="delivery-price")
		span.price-tariff__label(v-if="price.current.label") {{price.current.label}}&nbsp;
		.price-tariff__group(v-if="price.current" :class="{'price-tariff__group--clickable': price.current.arrow}" @click="emitClick")
			v-svg-icon.price-tariff__icon(v-if="view === 'rate'" icon="rate")
			span.price-tariff__prefix(v-if="price.current.prefix") {{price.current.prefix}}
			span.price-tariff__currency(v-if="price.current.currency && price.current.currency === '$'") {{price.current.currency}}&nbsp;
			span.price-tariff__value(v-if="price.current.value") {{price.current.value}}
			span.price-tariff__value(v-if="price.current.value2") &nbsp;- {{formatPrice(price.current.value2)}}
			span.price-tariff__currency(v-if="price.current.currency && price.current.currency !== '$'") {{price.current.currency}}
			span.price-tariff__postfix(v-if="price.current.arrow") &nbsp;{{price.current.postfix}}&nbsp;
			v-svg-icon.price-tariff__arrow(v-if="price.current.arrow" icon="price-arrow")
		.price-tariff__group.price-tariff__group--old(v-if="price.old")
			span.price-tariff__prefix(v-if="price.old.prefix") {{price.old.prefix}}&nbsp;
			span.price-tariff__value(v-if="price.old.value") {{price.old.value}}&nbsp;
			span.price-tariff__currency(v-if="price.old.currency") {{price.old.currency}}
			span.price-tariff__unit(v-if="price.old.unit") &nbsp;{{price.old.unit}}
</template>

<script>
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';

export default {
	mixins: [
		formattingMixin
	],

	props: {
		price: {
			type: Object,
			default: null
		},

		view: {
			type: String,
			default: 'regular'
		},

		size: {
			type: String,
			default: 'md'
		}
	},

	methods: {
		emitClick(e) {
			this.$emit('open-details', e);
		}
	}
};
</script>
